import { Company } from "../types";
import {
  canAccessEntikRecords,
  isDanielEntikCompany,
  ENTIK_RECORDS_COMPANY_ID,
} from "./entikRecordsAccess";

export const KIT_DIGITAL_PROJECT_SLUG = "kit-digital";
export const KIT_DIGITAL_COMPANY_ID = ENTIK_RECORDS_COMPANY_ID;
export const DANIEL_CIF = "50635458S";

export function canAccessKitDigital(
  company: Company | null | undefined,
  userEmail?: string | null,
  userRole?: string | null
): boolean {
  return canAccessEntikRecords(company, userEmail, userRole);
}

export function shouldShowKitDigitalTab(
  company: Company | null | undefined,
  userEmail?: string | null,
  userRole?: string | null
): boolean {
  return canAccessKitDigital(company, userEmail, userRole);
}

export function isDanielKitDigitalCompany(company: Company | null | undefined): boolean {
  return isDanielEntikCompany(company);
}
